/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { Box } from '@mui/material';
import Disclaimer from '../../../common/layout/header/Disclaimer';

const EXPORT_DISCLAIMER_WIDTH_PERCENTAGE = 65;

const PerformanceOutlookExportDisclaimer = () => {
  return (
    <Box sx={{ width: `${EXPORT_DISCLAIMER_WIDTH_PERCENTAGE}%`, marginRight: 'auto', marginLeft: 'auto' }}>
      <Disclaimer padding="40px 0px" />
    </Box>
  );
};

export default PerformanceOutlookExportDisclaimer;
